export default __webpack_public_path__ + "static/2-1b06549aebbca75819fc7294f4cd9452.jpeg";